import styled from "styled-components";

export const SectionTitleStyles = styled.div`
  display: flex;
  align-items: baseline;
  gap: 12px;
  margin: 28px 0 14px;

  .section-title__eyebrow {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.accent[500]};
    padding: 3px 8px;
    background: ${({ theme }) => theme.colors.accent[50]};
    border-radius: 999px;
  }

  .section-title__heading {
    font-size: 18px;
    font-weight: 600;
    margin: 0;
    letter-spacing: -0.1px;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
  }
`;
